// 파트너센터 「약관 서명 열기」 스위치 훅 — src/lib/partnerSigningOpen.js 의 React 포장.
//
//   const { enabled, loading } = usePartnerSigningOpen();
//   · enabled : 서명 단추를 열어도 되는가. 읽는 중·실패는 false — 열린 단추가 잠기는 것보다 잠긴 단추가 열리는 쪽이 문제다(fail-closed).
//   · loading : 아직 RPC 응답 전
// 값은 모듈 캐시에 한 번만 읽힌다. 어드민이 스위치를 바꾸면 lib 의 setPartnerSigningOpenCache 로 캐시가 바뀐다.
import { useEffect, useState } from "react";
import { fetchPartnerSigningOpen, getPartnerSigningOpenCache } from "../lib/partnerSigningOpen";

export default function usePartnerSigningOpen() {
  const [state, setState] = useState(() => {
    const c = getPartnerSigningOpenCache();
    return c ? { loading: false, enabled: c.enabled } : { loading: true, enabled: false };
  });
  useEffect(() => {
    let alive = true;
    fetchPartnerSigningOpen().then((c) => {
      if (alive) setState({ loading: false, enabled: c.enabled });
    });
    return () => { alive = false; };
  }, []);
  return state;
}
